<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>房车管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/car_house/parts">车型配件列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加车型配件</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加车型配件</span>
        <span class="xcx-add left font14" @click="reback()">返回列表</span>
      </div>
      <div class="xcx-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" style="width: 50%">
          <el-form-item label="配件名称：" prop="title">
            <el-col :span="20">
              <el-input placeholder="请填写配件名称" v-model="ruleForm.title"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="产品图" prop="thumb">
            <upload-one w="150px" h="100px" v-model="ruleForm.thumb"></upload-one>
          </el-form-item>
          <el-form-item label="品牌：" prop="brand">
            <el-col :span="20">
              <el-input placeholder="请填写品牌" v-model="ruleForm.brand"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="型号：" prop="model">
            <el-col :span="20">
              <el-input placeholder="请填写型号" v-model="ruleForm.model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="规格：" prop="specs">
            <el-col :span="20">
              <el-input placeholder="请填规格" v-model="ruleForm.specs"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="适配车型：" prop="fitter">
            <el-col :span="20">
              <el-input placeholder="请填适配车型" v-model="ruleForm.fitter"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="库存：" prop="stock">
            <el-col :span="20">
              <el-input placeholder="请填库存" v-model="ruleForm.stock"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="价格：" prop="price">
            <el-col :span="20">
              <el-input placeholder="请填价格" v-model="ruleForm.price"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="生产日期：" prop="stime">
            <el-col :span="20">
              <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.stime" type="date" placeholder="请填生产日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; height: 15px"></div>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-else>确认添加</el-button>

          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      loading: true,
      id: "",
      activeName: "first",
      ruleForm: {
        thumb: "",
        title: "",
        brand: "",
        model: "",
        specs: "",
        fitter: "",
        stock: 1,
        price: 0,
        stime: "",
      },
      category: [],
      rules: {
        brand: [{ required: true, message: "请输入", trigger: "blur" }],
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        thumb: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
    that.loading = false;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/car_parts/edit", { id: that.id }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
        }
      });
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/car_parts/store";
        if (that.id) {
          formData.id = that.id;
          url = "/car_parts/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/car_house/parts");
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 返回
     */
    reback() {
      this.$router.push("/car_house/parts");
    },
  },
};
</script>
<style>
.line {
  text-align: center;
}

.banner_img .updata_img .el-upload.el-upload--picture-card {
  width: 148px;
  height: 148px;
  line-height: 148px;
}

.quill-editor.quill-editor {
  width: 100%;
}

.ql-container.ql-snow {
  width: 100%;
}

.ql-toolbar.ql-snow {
  width: 100%;
}

.ql-container.ql-snow {
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>